export enum ButtonViewLayout {
    horizontal = 'horizontal',
    vertical = 'vertical',
    freeform = 'freeform',
}
